/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2497
 */

var r = require(/* 997 */"./2501/997")
module.exports = function () {
  this.__data__ = r ? r(null) : {}
  this.size = 0
}
